import React from "react";
import { useTranslation } from "react-i18next";
import "./placeholders.css";

/**
 * Referral placeholder (FE-6): prepared-only screen, no data yet. Title + COMING
 * SOON badge, three dimmed metric cards (all "—"), and a Top-Referrer card whose
 * ghost rows are blurred behind a centered "in Planung" overlay. Referral
 * analytics are Post-V1 (real data lands with the referral feature).
 */
export const ReferralScreen: React.FC = () => {
  const { t } = useTranslation();

  const metrics = [
    "placeholders.referral.metrics.registrations",
    "placeholders.referral.metrics.conversion",
    "placeholders.referral.metrics.activeReferrers",
  ];

  return (
    <div className="shell-content-narrow">
      <div className="view-header ph-header">
        <h1 className="view-title">{t("placeholders.referral.title")}</h1>
        <span className="ph-badge">{t("placeholders.comingSoon")}</span>
      </div>

      <div className="ph-metrics">
        {metrics.map((key) => (
          <div className="ph-metric" key={key}>
            <span className="ph-metric-label">{t(key)}</span>
            <span className="ph-metric-value">—</span>
          </div>
        ))}
      </div>

      <div className="ph-topref">
        <div className="ph-topref-head">{t("placeholders.referral.topReferrer")}</div>
        <div className="ph-topref-body">
          <div className="ph-ghost-rows" aria-hidden="true">
            {[0, 1, 2, 3].map((i) => (
              <div className="ph-ghost-row" key={i}>
                <span className="ph-ghost-avatar" />
                <span className="ph-ghost-line" />
                <span className="ph-ghost-pill" />
              </div>
            ))}
          </div>
          <div className="ph-overlay">
            <span className="ph-overlay-text">{t("placeholders.referral.overlay")}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
